import { NextPage, NextPageContext } from "next";
import Header from "@layouts/Main/lib/Header";
import Footer from "@layouts/Footer";
import InterestFormLevelOne from "@containers/InterestFormLevelOne";
import { getCatalogProductLevel } from "@libraries/api/product-level/product.repositories";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";
import { isAllowInterest } from "@config/feature";

const PageInterestFormLevelOne: NextPage<any> = ({ data, dataNavbar }) => {
  return (
    <>
      <Header />
      <InterestFormLevelOne {...data} />
      <Footer dataNavbar={dataNavbar} />
    </>
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const language = `${context.locale}`;
  const slug = `${context.query.level_one}`;
  const response = await getCatalogProductLevel(slug, language);
  const { data: dataProductMenu } = await getProductMenu({ level: 0 }, language);

  if (!isAllowInterest) {
    return {
      notFound: true,
    };
  }

  if (!response) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false,
      },
    };
  }

  const { data } = JSON.parse(JSON.stringify(response));

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
      title: `${data.productName} - Interest Form`,
      description: `${data.metaDescription}`,
      canonical: `${data.canonical + "/interest-form"}`,
      data,
      dataNavbar: dataProductMenu,
    },
  };
}

export default PageInterestFormLevelOne;
